import { ExportTable } from "../ExportTable/ExportTable";

export const Accounts = () => <ExportTable exportName="accounts" />;
